import React, { useState, useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "../../../config";
import { Link } from "react-router-dom";
import { Modal } from "antd";


import LogoBar from "../../components/common/logoBar";

import store from "../../redux/store";
import * as Actions from "../../redux/actions";
import Loading from "../../components/common/loading";

const GetProductsItf = ({
  productos,
  isInMyCatalog,
  ean,
  catalogoId,
  categoriaId,
  setReleatedProducts,
  marcaId,
  setSelectedProduct,
  setIsInMyCatalog
}) => {

  const navigate = useNavigate();

  return productos
    .sort((a, b) => a.rowIndex - b.rowIndex)
    .map((product, i) => {
      let imageStyle = {
        backgroundImage: `url(${api.media.images}${product.itf})`,
      };

      return (
        <Link key={i} to={product.itf}>
          <div className="block">
            <div className="content">
              <div className="delete-products-button">
                <div className="box">
                  {isInMyCatalog && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();

                        Modal.confirm({
                          title: "Confirmar",
                          content:
                            "Estas seguro/a que quieres eliminar este producto ?",
                          okText: "Eliminar",
                          cancelText: "Cancelar",
                          onOk: () => {
                            store
                              .dispatch(
                                Actions.deleteProducts({
                                  catalogId: catalogoId,
                                  categoryId: categoriaId,
                                  groupId: product.presentacion.toLowerCase().replace(/\s/g, "-"),
                                  ean: product.ean,
                                  itf: product.itf,
                                })
                              )
                              .then(() => {
                                store
                                .dispatch(Actions.getProducts(catalogoId, categoriaId, marcaId))
                                .then((data) => {
                                  const products = data.payload.data.products;
                          
                                  setIsInMyCatalog(data.payload.data.isInMyCatalog);
                                  setSelectedProduct(
                                    Object.keys(products)
                                      .map((key) => products[key].find((product) => product.ean === ean))
                                      .filter((e) => e)
                                  );
                          
                                  store
                                    .dispatch(
                                      Actions.getProductsByEAN(catalogoId, categoriaId, marcaId, ean)
                                    )
                                    .then((data) => {
                                      if(data.payload.data.productsByEan.length === 0) {
                                        return navigate(`/catalogos/${catalogoId}/${categoriaId}/${marcaId}`);

                                      } else {
                                        setIsInMyCatalog(data.payload.data.isInMyCatalog);
                                        setReleatedProducts(data.payload.data.productsByEan);
                                      }
                                 
                                    });
                                });
                              });
                          },
                        });
                      }}
                    >
                      <div className="icon-descargar">
                        <img src="/assets/img/delete-icon.png" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="image" style={imageStyle} />
              <div className="description">
                <div className="productTitle type">
                  <span className="productCode">{product.code}</span>
                  <div className="center-line" />
                  <span className="productUnity">
                    {product.extendeddescription}
                  </span>
                </div>
                <div className="center-line" />
                <div className="productTitle ean">
                  C.ITF: <span>{product.itf}</span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      );
    });
};

const GetProductEan = ({ product }) => {


  let imageStyle = {
    backgroundImage: `url(${api.media.images}${product.ean})`,
  };

  return (
    <div className="block icon">
      <div className="content">
        <div className="image" style={imageStyle} />
        <div className="productTitle type">{product.titulo}</div>
        <div className="center-line" />
        <div className="productTitle ean">
          C.EAN: <span>{product.ean}</span>
        </div>
      </div>
    </div>
  );
};

const productsType = () => {
  let { catalogoId, categoriaId, marcaId, ean } = useParams();
  const [isInMyCatalog, setIsInMyCatalog] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState();
  const [releatedProducts, setReleatedProducts] = useState();

  useEffect(() => {
    store
    .dispatch(
      Actions.getProductsByEAN(catalogoId, categoriaId, marcaId, ean)
    )
    .then((data) => {

      setIsInMyCatalog(data.payload.data.isInMyCatalog);
      setReleatedProducts(data.payload.data.productsByEan);
    });

  }, []);
  
  return (
    <>
      {!releatedProducts && <Loading />}
      {releatedProducts && (
        <>
          <div className="productType-container">
            <LogoBar selectedProduct={releatedProducts && [releatedProducts[0]]} />
            <div className="blocks-container">
              <div className="blocks">
                <GetProductEan
                  product={releatedProducts && releatedProducts[0]}
                />
                <GetProductsItf
                  productos={releatedProducts}
                  ean={ean}
                  categoriaId={categoriaId}
                  catalogoId={catalogoId}
                  isInMyCatalog={isInMyCatalog}
                  setReleatedProducts={setReleatedProducts}
                  marcaId={marcaId}
                  setSelectedProduct={setSelectedProduct}
                  setIsInMyCatalog={setIsInMyCatalog}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default productsType;
